import React from 'react'
import { useParams } from 'react-router-dom';
import { usePermissionGuardRedirect } from '../../../hooks/usePermissionGuard';
import { GetCertificateAuditFilters, GetCertificateAuditTrails } from '../../../services/CertificateServices';
import { RenderCertificateResourceType } from '../../../utils/CommonGroupingItem';
import AuditTrailsTable from '../../common/AuditTrailsTable';

function AuditTrail() {
    const { id, tab } = useParams();

    usePermissionGuardRedirect(['intakeCopyView']);  
    
    const columnsToShow = ["Action Type", "Resource Type", "Resource Name"]
    // TODO add both api's in this table to make it working
    return (
      <AuditTrailsTable
        apiFunction={GetCertificateAuditTrails}
        apiParams={id ? { action_id: id } : {}}
        actionId={id}
        columnsToShow={columnsToShow}
        filterArrApi={GetCertificateAuditFilters}
        exportFileName={"Certificate_template_audittrail"}
        isShowingResourceTypeFilter
        renderResourceTypeFunction={RenderCertificateResourceType}
        isResourceNameShown={true}
      />
    )
  }

export default AuditTrail